import React, { useState } from 'react';
import { useAdminConfig } from '../../hooks/useAdminConfig';
import { Card } from '../../components/ui/Card';
import { LoadingSpinner } from '../../components/ui/Feedback';
import { SLARuleEditor } from '../../components/admin/SLARuleEditor';
import { ShieldAlert } from 'lucide-react';

export const PrioritiesPage: React.FC = () => {
  const { priorities, isLoading, createPriority, updatePriority, deletePriority } = useAdminConfig();

  if (isLoading) return <LoadingSpinner size="lg" text="Loading Priorities..." />;

  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-lg font-semibold text-slate-100 flex items-center gap-2">
          <ShieldAlert className="w-5 h-5 text-sky-400" />
          Priorities & SLA Rules
        </h3>
        <p className="text-xs text-slate-400">Configure priority levels and their SLA durations</p>
      </div>

      <Card title="Priority Levels & SLA Configuration">
        <SLARuleEditor
          priorities={priorities}
          onUpdate={updatePriority}
          onCreate={createPriority}
          onDelete={deletePriority}
        />
      </Card>
    </div>
  );
};
